<template>
  <div class="footer">
    <div class="wrapper1">
      <div class="banquan">
        <div class="text">
          <div class="footer-row">
            <span class="title_new">上海中小企业国际合作协会 版权所有</span>
            <a href="https://beian.miit.gov.cn/" target="_blank" class="beian-link">沪ICP备2021007053号-3</a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702007433" target="_blank" class="beian-link">
              沪公网安备31010702007433号
            </a>
          </div>
          
          <div class="footer-row">
            <span class="title_new">官方邮箱：siab@siab.org.cn</span>
            <span class="title_new" style="margin-left: 15px;">地址：上海市黄浦区北京东路668号科技京城东楼18H</span>
          </div>
        </div>
        
        <div class="img-container">
          <img src="../assets/img1/footlogo.jpg" class="qrcode">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/img1/footlogo.jpg";
export default {
    name: "WebFooter",
    data(){
    return{
      logo: logo,
    }
  }
}
</script>

<style scoped>
/* 直接引入外部 CSS */
@import "@/assets/css/footer_combined.css";
</style>